import { EvalFeedbackStatus } from '../enums/EvalFeedbackStatus';
import { EvalPeerReviewData } from '../interfaces/EvalPeerReviewData';

export const clientsReviewsShowFilter = (clientReview: EvalPeerReviewData): boolean =>
  clientReview.status === EvalFeedbackStatus.Submitted;
export const peersReviewsShowFilter = (peerReview: EvalPeerReviewData): boolean =>
  peerReview.status === EvalFeedbackStatus.Approved;
